'use es6';

import I18n from 'I18n';
import { isObject, isArray, mapObject, groupBy } from 'underscore';
import { BAD_REQUEST } from 'DesignData/enums/HttpStatusCodes';
import { TEMPLATE_VALIDATION_FAILED } from 'DesignData/enums/ErrorTypes';
const TEMPLATE_VALIDATION_ERROR_TYPE = TEMPLATE_VALIDATION_FAILED;
const UNKNOWN_ERROR_CATEGORY = 'UNKNOWN';
const MAX_DISPLAY_LENGTH = 200;

const i18nKey = key => `designManager.templateError.${key}`;

function formatMessages(header, messages) {
  const truncatedMessages = messages.map(msg => msg.slice(0, MAX_DISPLAY_LENGTH)).join('\n');
  return `${header}\n${truncatedMessages}`;
}

function getTemplateValidationError(category, errors) {
  const defaultValue = I18n.text(i18nKey('errorHeader.errorWasFound'), {
    count: errors.length
  });
  const errorHeader = I18n.text(i18nKey(`errorHeader.${category}`), {
    defaultValue,
    count: errors.length
  });

  if (category === UNKNOWN_ERROR_CATEGORY) {
    const messages = errors.map(_error => {
      const {
        message,
        errorType,
        errorTokens = {}
      } = _error;

      if (message) {
        return message;
      }

      const values = {
        errorType
      };

      if (errorTokens.line) {
        values.line = errorTokens.line[0];
      }

      return I18n.text(i18nKey(`errorBody.${category}`), {
        values: JSON.stringify(values)
      });
    });
    return formatMessages(errorHeader, messages);
  }

  const messages = errors.map(_error => {
    const tokens = _error.errorTokens || {};
    const errorValues = mapObject(tokens, v => v[0]);
    return I18n.text(i18nKey(`errorBody.${category}`), Object.assign({}, errorValues, {
      defaultValue: ''
    }));
  });
  return formatMessages(errorHeader, messages);
}

export function isBadRequestError(error) {
  return error && error.status === BAD_REQUEST;
}
export function getErrorData(error) {
  if (!error) {
    return null;
  }

  try {
    return error.data && JSON.parse(error.data);
  } catch (e) {
    return null;
  }
}
export function getBadRequestErrorMessages(error) {
  const errorData = getErrorData(error);

  if (!(errorData && isObject(errorData))) {
    return [];
  }

  const {
    errorType,
    errors,
    message
  } = errorData;

  if (errorType === TEMPLATE_VALIDATION_ERROR_TYPE) {
    const errorsByCategory = groupBy(errors, _error => {
      const {
        category
      } = _error.errorTokens || {};
      return category && isArray(category) ? category[0] : '';
    });
    return Object.keys(errorsByCategory).map(category => {
      return getTemplateValidationError(category, errorsByCategory[category]);
    });
  } else if (isArray(errors)) {
    return errors;
  } else if (message) {
    return [message];
  }

  return [];
}